export const fragmentLabel = (f) => f && f.acceptWhenMeasured ? 'application queued' : f && f.acceptError ? 'application failed' : 'fragment to judge';

export function turnStatus(f, t) {
  const live = t.cards.filter((c) => !c.accepted && c.phase !== 'done');
  const passOnIt = f.pass && (!f.pass.params || !f.pass.params.turns || f.pass.params.turns.includes(t.i));
  if (t.draft || (t.edits || []).some((e) => !e.accepted) || live.some((c) => c.phase === 'undecided') || (passOnIt && f.pass.status === 'needs_human')) return 'needs';
  if (t.fragment && t.fragment.acceptWhenMeasured) return 'progress';
  if (t.fragment && t.fragment.acceptError) return 'blocked';
  if (t.fragment) return 'needs';
  if ((passOnIt && ['queued', 'running'].includes(f.pass.status)) || live.some((c) => ['queued', 'running'].includes(c.status))) return 'progress';
  if (live.length || t.requested) return 'open';
  if (t.cards.length || t.accepted) return 'settled';
  return 'none';
}
